module.exports = __webpack_public_path__ + "img/style2_b87983031.png";